<template>
  <EquipmentInfo :equipment-id="equipmentData.equipment_id" :info="info" />
</template>

<script>
import { mapGetters } from 'vuex';
import { mapEquipmentFields, mapCorrespondingEquipmentFields } from '@/utils';
import EquipmentInfo from './EquipmentInfo.vue';

export default {
  name: 'EquipmentInfoContainer',
  components: {
    EquipmentInfo,
  },
  props: {
    equipmentData: {
      type: Object,
      default: () => ({}),
    },
    calledBySphericalView: {
      type: Boolean,
      default: false,
    },
    modalView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      inspectionConfig: 'config/inspectionConfig',
    }),
    info() {
      // Map config equipmentInfoFields paths to corresponding nonAggregateEquipmentHeaders value of equipmentData
      // ToDo: store data in Vuex so it is consistent - API call in Sherical, Inspection reuses data in equipment table
      const {
        nonAggregateEquipmentHeaders,
        equipmentInfoFields,
        corrosionLayers,
        platformFeatures,
      } = this.inspectionConfig;
      if (this.calledBySphericalView) {
        return mapEquipmentFields({
          equipmentInfoFields,
          corrosionLayers,
          equipmentData: this.equipmentData,
          platformFeatures,
          isModalView: this.modalView,
        });
      }

      return mapCorrespondingEquipmentFields(
        nonAggregateEquipmentHeaders,
        equipmentInfoFields,
        corrosionLayers,
        this.equipmentData
      );
    },
  },
};
</script>
